import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaBackward, FaThumbsUp, FaThumbsDown, FaBan, FaCheck } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { bin2base64, bin2hex, dataMysql, extract, hex2bin, utf8Decode, utf8Encode } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import NavItem from '../../../components/NavItem';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import MostrarHTML from '../../../components/MostrarHtml';
import Alert from '../../../components/Alert';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteAceitarTermo({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [data, setData] = useState(null);
    const [concordaTermo, setConcordaTermo] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    var idEvento = state?.evento ?? null;
    const idioma = data?.idioma || state?.idioma || null;

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            api({
                method: "get",
                action: '/eventoCarta/visualizarCartaHtml/' + id,
                token: token,
                params: {
                    tipoCarta: "modelotermoaceite",
                }
            }).then(response => {
                setData({
                    ...dadosRecebidos,
                    ...{ htmlCartaConvite: response.data.data.htmlCarta }
                });
                setIsLoading(false);
            }).catch(function () {
                const msg = idioma
                    ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(msg);
                setIsLoading(false);
                setIsError(true);
            });
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            const message = idioma
                ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
            toast.error(message);
        });
    };//buscar

    const salvar = (aceitouTermo) => {
        setIsSubmitting(true);
        api({
            method: 'put',
            action: '/participante/aceitarTermo/' + id,
            token: token,
            data: { executarAceitouTermo: aceitouTermo ? 'sim' : 'nao' },
        })
            .then(function () {
                if (aceitouTermo) {
                    history.push("/cadastroEventoParticipanteConvite/" + id, { idioma: idioma });
                } else {
                    history.push("/cadastroEventoParticipanteConviteRecusado/" + data?.evento?.id, { idioma: idioma });
                }
            })
            .catch(function () {
                const message = idioma
                    ? `${getText('error', idioma)} ${getText('errorSavingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorSavingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <ul className="nav">
                    {['listarsvp'].includes(perfil) ? <NavItem to={"/eventoParticipante/" + idEvento} icon={<FaBackward size={20} />} color="outline-dark">Participantes</NavItem> : null}
                </ul>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <MostrarHTML
                                                    htmlContent={data?.htmlCartaConvite ?? null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('termoLgpd', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <p>{getText('lgpdInfo1', idioma)}</p>
                                                <p>{getText('lgpdInfo2', idioma)}</p>
                                                <p>{getText('lgpdInfo3', idioma)}</p>
                                                <p>{getText('lgpdInfo4', idioma)}</p>
                                                <p>{getText('lgpdInfo5', idioma)}</p>
                                                <p>{getText('lgpdInfo6', idioma)}</p>
                                                <p>{getText('downloadTerms', idioma)} <a rel="noreferrer" target="_blank" href={process.env.REACT_APP_API_URL + "/termo_lgpd.pdf"}>{getText('downloadLgpdTerms', idioma)}</a></p>
                                            </div>
                                        </div>
                                        {!isLoading && !isError && data?.evento && (
                                            <>
                                                <div className="row">
                                                    <div className="col-sm-12 d-flex justify-content-end">
                                                        <div className="form-check">
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input type="checkbox"
                                                                        className="form-check-input"
                                                                        value={concordaTermo}
                                                                        checked={concordaTermo}
                                                                        onChange={(value) => {
                                                                            setConcordaTermo(!concordaTermo);
                                                                        }} />
                                                                    {getText('agreeWithTerms', idioma)}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 d-flex justify-content-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger me-1 mb-1"
                                                            disabled={isSubmitting}
                                                            onClick={() => {
                                                                Alert({
                                                                    title: getText('temCerteza', idioma),
                                                                    icon: "warning",
                                                                    html: <>{getText('lgpdWarning', idioma)}</>,
                                                                    confirmButton: getText('voltar', idioma),
                                                                    denyButton: getText('naoAceitoOsTermosConfirm', idioma),
                                                                    callBack: (result) => {
                                                                        if (result.isDenied) {
                                                                            salvar(false);
                                                                        }
                                                                    },
                                                                });
                                                            }}
                                                        >
                                                            <FaBan size={20} /> {getText('naoAceitoOsTermos', idioma)}
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success me-1 mb-1"
                                                            disabled={!concordaTermo || isSubmitting}
                                                            onClick={() => {
                                                                salvar(true);
                                                            }}
                                                        >
                                                            <FaCheck size={20} /> {getText('aceitoOsTermos', idioma)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
